import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-b border-line bg-canvas" data-id="element-42" data-mp="1nwvwmzb64jqt">
      <div className="mx-auto max-w-2xl px-4 py-8 sm:py-10" data-id="element-43" data-mp="2bkvvkmimvggh">
        <SectionHeader id="faq" title="Preguntas frecuentes" data-id="element-44" data-mp="2fm7cm3nfytd2" />
        <div className="mt-4 space-y-2" data-id="element-45" data-mp="2fns5zpy0s69c">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className={`rounded-xl border bg-surface transition-colors duration-150 ease-soft ${isOpen ? 'border-accent/60' : 'border-line'}`} data-id="element-46" data-mp="26suf0oefn3kn" data-mpi={i}>
                <h3 data-id="element-47" data-mp="2zc1bf1okq8qs">
                  <button type="button" id={`faq-trigger-${i}`} onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-3.5 py-3 text-left" data-id="element-48" data-mp="1vphvk3jirzuy">
                    <span className="font-display text-sm font-semibold text-ink" data-id="element-49" data-mp="2fdqm695ezxsc">{faq.q}</span>
                    <ChevronDownIcon size={16} aria-hidden="true" className={`flex-shrink-0 text-accent transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-50" data-mp="2ffl5xk4y9juu" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-51" data-mp="u0xme8k7gfne">
                  {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-trigger-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-52" data-mp="p2dyi2m1wtse">
                      <p className="px-3.5 pb-3 text-[0.8rem] leading-snug text-muted sm:text-sm" data-id="element-53" data-mp="3837ytg31zxnx">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}